import { EncounterActionType } from '../../../../app/data/interaction/action-type';
import { pipe } from 'ramda';
import { hasLastActionOf } from '../../../../app/core/encounter/interaction';
import { selectOpponentEvents } from './encounter-events.selector';

export const selectIsOpponentDoing = (action: EncounterActionType) =>
  pipe(selectOpponentEvents, hasLastActionOf(action));
